







import Vue from 'vue';
import ContentWithSidebar from '../components/ContentWithSidebar.vue';
import ViewItem from '../components/ViewItem.vue';

export default Vue.extend({

    components: {
        ContentWithSidebar,
        ViewItem,
    },

    computed: {
        item() {
            return this.$store.state.universeItem;
        }
    },

    mounted() {
        this.loadData(this.$route.params);
    },

    watch: {
        $route(value: string, oldValue: string) {
            this.loadData(this.$route.params);
        },
    },

    methods: {
        loadData(params: any) {
            const subject = params.subject && params.subject.length > 0 ? params.subject : 'All about GWTP';
            this.$store.dispatch('loadUniverseItem', { subject });
        }
    }

});
